<template>
  <b-container style="padding-top: 150px;">
    <div>
      <h2>SUBSCRIPTION SERVICE AGREEMENT</h2>

      <p>
        This Subscription Service Agreement ("Agreement") is entered into by and
        between [Company Name], a [Legal Structure] with its principal office
        located at [Company Address] ("Company") and [Subscriber's Legal Name],
        with its principal address at [Subscriber's Address] ("Subscriber").
        This Agreement is effective as of [Effective Date].
      </p>

      <h6>1. INTRODUCTION:</h6>
      <p>
        This Agreement governs the use of the HeartBeatFam SaaS (Software as a
        Service) platform ("Services"). By accessing or using the Services,
        Subscriber agrees to be bound by the terms and conditions of this
        Agreement.
      </p>

      <h6>2. SERVICES:</h6>
      <p>
        2.1 Company agrees to provide Subscriber with access to the HeartBeatFam
        SaaS platform, including features and functionalities as described in
        the accompanying documentation.
      </p>

      <h6>3. MODIFICATION:</h6>
      <p>
        3.1 Subscriber acknowledges that Company may modify the Services,
        including features, functionalities, and terms of this Agreement, with
        notice to Subscriber. Continued use of the Services after such
        modifications constitutes acceptance of the modified terms.
      </p>

      <h6>4. SUBSCRIBER'S ACCOUNT:</h6>
      <p>
        4.1 Subscriber is responsible for maintaining the confidentiality of
        login credentials and ensuring the security of its account. Subscriber
        agrees to promptly notify Company of any unauthorized use or suspected
        security breaches.
      </p>

      <h6>5. RESTRICTION:</h6>
      <p>
        5.1 Subscriber agrees not to: (a) reverse engineer, decompile, or
        disassemble the Services; (b) interfere with the proper functioning of
        the Services; (c) use the Services for illegal or unauthorized purposes.
      </p>

      <h6>6. COMPLIANCE:</h6>
      <p>
        6.1 Subscriber is responsible for compliance with all applicable laws,
        regulations, and this Agreement. Subscriber shall not use the Services
        for any unlawful or prohibited purpose.
      </p>

      <h6>7. TERM:</h6>
      <p>
        7.1 This Agreement shall commence on the Effective Date and continue for
        the initial term specified in the selected subscription plan.
      </p>

      <h6>8. MUTUAL TERMINATION FOR CAUSE:</h6>
      <p>
        8.1 Either party may terminate this Agreement with written notice if the
        other party breaches any material term or condition of this Agreement.
        Termination will be effective [number of days] days after notice unless
        the breach is cured within the specified period.
      </p>
      <h6>9. TERMINATION BY COMPANY:</h6>
      <p>
        9.1 Company may terminate this Agreement with notice if Subscriber fails
        to comply with any material term or condition of this Agreement.
      </p>

      <h6>10. FEES, PAYMENT, AND BILLING:</h6>
      <p>
        10.1 Subscriber agrees to pay the subscription fees in accordance with
        the selected subscription plan. Payment shall be made [monthly/annually]
        and is due on the [billing date].
      </p>

      <h6>11. TAXES:</h6>
      <p>
        11.1 Subscriber is responsible for any applicable taxes related to the
        subscription fees.
      </p>

      <h6>12. CONFIDENTIAL INFORMATION DEFINITION:</h6>
      <p>
        12.1 "Confidential Information" includes non-public information
        disclosed by one party to the other.
      </p>

      <h6>13. PROTECTION OF CONFIDENTIAL INFORMATION:</h6>
      <p>
        13.1 Each party agrees to maintain the confidentiality of the other
        party's Confidential Information and not disclose it to third parties.
      </p>

      <h6>14. SECURITY:</h6>
      <p>
        14.1 Company employs industry-standard measures to protect Subscriber's
        data. However, Company cannot guarantee the security of data transmitted
        over the internet.
      </p>

      <h6>15. INTELLECTUAL PROPERTY RIGHTS:</h6>
      <p>
        15.1 Subscriber acknowledges that the Services and any associated
        intellectual property rights are owned by Company.
      </p>

      <h6>16. SUBSCRIBER DATA:</h6>
      <p>
        16.1 Subscriber retains ownership of any data it uploads or enters into
        the Services ("Subscriber Data").
      </p>
      <h6>17. WARRANTIES:</h6>
      <p>
        17.1 Company makes no warranties, express or implied, regarding the
        Services, including fitness for a particular purpose or
        non-infringement.
      </p>

      <h6>18. COMPANY WARRANTIES:</h6>
      <p>
        18.1 Company warrants that it will provide the Services in a manner
        consistent with general industry standards reasonably applicable to the
        provision thereof.
      </p>

      <h6>19. DISCLAIMERS:</h6>
      <p>
        19.1 The Services are provided "as is" and "as available." Company
        disclaims all warranties, including the implied warranties of
        merchantability and fitness for a particular purpose.
      </p>

      <h6>20. INDEMNIFICATION BY COMPANY:</h6>
      <p>
        20.1 Company agrees to indemnify and hold Subscriber harmless from any
        third-party claims arising out of the Services, provided that Subscriber
        promptly notifies Company of any such claim.
      </p>
      <h6>21. INDEMNIFICATION BY SUBSCRIBER:</h6>
      <p>
        21.1 Subscriber agrees to indemnify and hold Company harmless from any
        third-party claims arising out of Subscriber's use of the Services or
        violation of this Agreement.
      </p>

      <h6>22. EXCLUSION OF DAMAGES:</h6>
      <p>
        22.1 In no event shall either party be liable for any consequential,
        incidental, indirect, special, or punitive damages arising out of or
        related to this Agreement.
      </p>

      <h6>23. LIMITATION OF LIABILITY:</h6>
      <p>
        23.1 Company's total liability under this Agreement, whether in
        contract, tort, or otherwise, shall not exceed the total fees paid by
        Subscriber during the twelve months preceding the claim.
      </p>

      <h6>24. JURISDICTION-SPECIFIC EXCLUSIONS:</h6>
      <p>
        24.1 Some jurisdictions may not allow the exclusion of certain
        warranties or the limitation of liability. In such cases, the above
        limitations or exclusions may not apply.
      </p>
      <h6>25. EXPORT COMPLIANCE:</h6>
      <p>
        25.1 Subscriber agrees to comply with all export control laws and
        regulations applicable to the use of the Services.
      </p>

      <h6>26. USE RESTRICTIONS:</h6>
      <p>
        26.1 Subscriber agrees not to use the Services in a way that violates
        any applicable laws, regulations, or this Agreement.
      </p>

      <h6>27. GOVERNING LAW:</h6>
      <p>
        27.1 This Agreement shall be governed by and construed in accordance
        with the laws of the state of [State], without regard to its conflict of
        law principles.
      </p>

      <h6>28. SEVERABILITY:</h6>
      <p>
        28.1 If any provision of this Agreement is held to be invalid or
        unenforceable, the remaining provisions shall continue in full force and
        effect.
      </p>

      <h6>29. ASSIGNMENT:</h6>
      <p>
        29.1 Subscriber may not assign this Agreement without the prior written
        consent of Company. Any unauthorized assignment is void.
      </p>

      <h6>30. FORCE MAJEURE:</h6>
      <p>
        30.1 Neither party shall be liable for any failure or delay in
        performance under this Agreement due to events beyond its reasonable
        control.
      </p>

      <h6>31. WAIVER:</h6>
      <p>
        31.1 The failure of either party to enforce any provision of this
        Agreement shall not constitute a waiver of that provision or any other
        provision.
      </p>

      <h6>32. ENTIRE AGREEMENT:</h6>
      <p>
        32.1 This Agreement constitutes the entire understanding between the
        parties and supersedes all prior agreements, whether oral or written.
      </p>
    </div>
    <div v-if="false">
      <h1>Subscription Service Agreement</h1>

      <h2>1. Subscription Services:</h2>
      <p>
        1.1 HeartBeatFam agrees to provide the Subscriber access to its family
        care platform, including but not limited to its suite of MyApps, shared
        calendars, health records, communication tools, and other features
        (collectively, the "Services").
      </p>

      <p>
        1.2 The Services are provided on a subscription basis, and Subscriber
        agrees to pay the applicable subscription fees as outlined in Section 2.
      </p>

      <h2>2. Subscription Fees:</h2>
      <p>
        2.1 Subscriber agrees to pay the subscription fees in accordance with
        the selected subscription plan.
      </p>

      <p>
        2.2 HeartBeatFam reserves the right to adjust subscription fees with
        notice to the Subscriber. Changes to subscription fees will be effective
        at the beginning of the next billing cycle.
      </p>

      <p>
        2.3 In the event of late payment, HeartBeatFam may suspend access to the
        Services until payment is received.
      </p>
      <h2>3. Term and Termination:</h2>
      <p>
        3.1 This Agreement shall commence on the Effective Date and continue for
        the initial term specified in the selected subscription plan.
      </p>

      <p>
        3.2 Either party may terminate this Agreement with written notice if the
        other party breaches any material term or condition of this Agreement.
        Termination will be effective [number of days] days after notice, unless
        the breach is cured within the specified period.
      </p>

      <p>
        3.3 Upon termination, Subscriber's access to the Services will be
        discontinued, and any outstanding fees shall become immediately due and
        payable.
      </p>

      <h2>4. Use of Services:</h2>
      <p>
        4.1 Subscriber agrees to use the Services in compliance with all
        applicable laws, regulations, and this Agreement.
      </p>

      <p>
        4.2 HeartBeatFam reserves the right to monitor Subscriber's use of the
        Services to ensure compliance with this Agreement.
      </p>

      <h2>5. Confidentiality:</h2>
      <p>
        5.1 Subscriber acknowledges that the Services may contain confidential
        and proprietary information. Subscriber agrees to maintain the
        confidentiality of such information and not disclose it to third
        parties.
      </p>

      <h2>6. Data Security:</h2>
      <p>
        6.1 HeartBeatFam employs industry-standard measures to protect
        Subscriber's data. However, HeartBeatFam cannot guarantee the security
        of data transmitted over the internet.
      </p>

      <p>
        6.2 Subscriber is responsible for maintaining the confidentiality of
        login credentials and for all activities occurring under Subscriber's
        account.
      </p>

      <h2>7. Limitation of Liability:</h2>
      <p>
        7.1 HeartBeatFam shall not be liable for any indirect, incidental,
        consequential, or punitive damages arising out of or in connection with
        this Agreement or the use of the Services.
      </p>

      <p>
        7.2 HeartBeatFam's total liability under this Agreement shall not exceed
        the total subscription fees paid by Subscriber in the [six (6)
        months/one (1) year] preceding the event giving rise to the claim.
      </p>

      <h2>8. Governing Law:</h2>
      <p>
        8.1 This Agreement shall be governed by and construed in accordance with
        the laws of the State of California.
      </p>

      <p>
        8.2 Any legal action or proceeding arising out of or relating to this
        Agreement shall be brought exclusively in the state or federal courts
        located in the State of California.
      </p>

      <p>
        IN WITNESS WHEREOF, the parties hereto have executed this Subscription
        Service Agreement as of November 29, 2023.
      </p>

      <h6>PonyEngine Inc, Dba HeartBeatFam:</h6>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "Policy_Data"
};
</script>
